import { createAction, props } from '@ngrx/store';

import { Barn, Discount, DosatorSetting, Silo } from '../../models/settings.model';
import {
  LeeOAuthentication,
  LeeOAuthenticationUpsertedResponse,
  NedapInstallation,
  UpdateNedapInstallationMetaDataRequest,
  UpdateNedapInstallationMetaDataResponse,
  UpsertLeeOAuthenticationRequest,
} from '../../models/third-parties.model';

export const loadEnergySetting = createAction('[UomSetting] Load Energy setting');
export const loadLysineSetting = createAction('[UomSetting] Load Lysine setting');

export const setUomSetting = createAction(
  '[UomSetting] Set Unit of Measure',
  props<{ system: string; value: string; save: boolean }>(),
);

/** BARN SETTING ACTIONS */
export const loadBarnsRequest = createAction('[Barn] Load barns request');
export const loadBarnsSuccess = createAction(
  '[Barn] Load barns success',
  props<{ barns: Barn[] }>(),
);
export const loadBarnsFailed = createAction('[Barn] Load barns failed', props<{ error: Error }>());

export const upsertBarnRequest = createAction(
  '[Barn] Upsert barn request',
  props<{ barn: Barn }>(),
);
export const upsertBarnSuccess = createAction(
  '[Barn] Upsert barn success',
  props<{ barn: Barn }>(),
);
export const upsertBarnFailed = createAction(
  '[Barn] Upsert barn failed',
  props<{ error: Error }>(),
);

export const deleteBarnRequest = createAction(
  '[Barn] Delete barn request',
  props<{ barn: Barn }>(),
);
export const deleteBarnWithConfirmation = createAction(
  '[Barn] Confirm Delete barn',
  props<{ barn: Barn }>(),
);
export const deleteBarnSuccess = createAction(
  '[Barn] Delete barn success',
  props<{ barn: Barn }>(),
);
export const deleteBarnFailed = createAction(
  '[Barn] Delete barn failed',
  props<{ error: Error }>(),
);

export const upsertBarn = createAction('[Barn] Upsert barn', props<{ barn: Barn }>());
export const setSelectedBarn = createAction(
  '[Barn] Set Selected barn',
  props<{ barnId?: number }>(),
);

/** SILOS SETTING ACTIONS */
export const loadSilosRequest = createAction('[Silo] Load silos request');
export const loadSilosSuccess = createAction(
  '[Silo] Load silos success',
  props<{ silos: Silo[] }>(),
);
export const loadSilosFailed = createAction('[Silo] Load silos failed', props<{ error: Error }>());

/** DISCOUNT ACTIONS */
export const loadDiscountRequest = createAction('[Discount] Load Discount request');
export const loadDiscountSuccess = createAction(
  '[Discount] Load Discount success',
  props<{ discount: Discount }>(),
);
export const loadDiscountFailed = createAction(
  '[Discount] Load Discount failed',
  props<{ error: Error }>(),
);
export const upsertDiscountRequest = createAction(
  '[Discount] Upsert Discount request',
  props<{ discount: Discount }>(),
);
export const upsertDiscountSuccess = createAction(
  '[Discount] Upsert Discount success',
  props<{ id: number }>(),
);
export const upsertDiscountFailed = createAction(
  '[Discount] Upsert Discount failed',
  props<{ error: Error }>(),
);

/** NEDAP INSTALLATION ACTIONS */
export const loadNedapInstallationsRequest = createAction(
  '[Nedap] Load NedapInstallations request',
);
export const loadNedapInstallationsSuccess = createAction(
  '[Nedap] Load NedapInstallations success',
  props<{ nedapInstallations: NedapInstallation[] }>(),
);
export const loadNedapInstallationsFailed = createAction(
  '[Nedap] Load NedapInstallations failed',
  props<{ error: Error }>(),
);
export const updateNedapInstallationMetaDataRequest = createAction(
  '[Nedap] Update NedapInstallation MetaData request',
  props<{ nedapInstallation: UpdateNedapInstallationMetaDataRequest }>(),
);
export const updateNedapInstallationMetaDataSuccess = createAction(
  '[Nedap] Update NedapInstallation MetaData success',
  props<{ nedapInstallation: UpdateNedapInstallationMetaDataResponse }>(),
);
export const updateNedapInstallationMetaDataFailed = createAction(
  '[Nedap] Upsert NedapInstallation MetaData failed',
  props<{ error: Error }>(),
);

/** LEEO ACTIONS */
export const loadLeeOAuthenticationRequest = createAction('[LeeO] Load LeeOAuthentication request');
export const loadLeeOAuthenticationSuccess = createAction(
  '[LeeO] Load LeeOAuthentication success',
  props<{ leeOAuthentication: LeeOAuthentication }>(),
);
export const loadLeeOAuthenticationFailed = createAction(
  '[LeeO] Load LeeOAuthentication failed',
  props<{ error: Error }>(),
);
export const upsertLeeOAuthenticationRequest = createAction(
  '[LeeO] upsertLeeOAuthentication request',
  props<{ upsertLeeOAuthenticationRequest: UpsertLeeOAuthenticationRequest }>(),
);
export const upsertLeeOAuthenticationSuccess = createAction(
  '[LeeO] upsertLeeOAuthentication success',
  props<{ leeOAuthenticationUpsertedResponse: LeeOAuthenticationUpsertedResponse }>(),
);
export const upsertLeeOAuthenticationFailed = createAction(
  '[LeeO] upsertLeeOAuthentication failed',
  props<{ error: Error }>(),
);
export const deleteLeeOAuthenticationRequest = createAction(
  '[LeeO] Delete LeeOAuthentication request',
  props<{ leeOAuthenticationId: number }>(),
);
export const deleteLeeOAuthenticationWithConfirmation = createAction(
  '[LeeO] Confirm Delete LeeOAuthentication',
  props<{ leeOAuthenticationId: number }>(),
);
export const deleteLeeOAuthenticationSuccess = createAction(
  '[LeeO] Delete LeeOAuthentication success',
  props<{ leeOAuthenticationId: number }>(),
);

/** DOSATORSETTING SETTING ACTIONS */
export const loadDosatorSettingsRequest = createAction(
  '[DosatorSetting] Load dosatorSettings request',
);
export const loadDosatorSettingsSuccess = createAction(
  '[DosatorSetting] Load dosatorSettings success',
  props<{ dosatorSettings: DosatorSetting[] }>(),
);
export const loadDosatorSettingsFailed = createAction(
  '[DosatorSetting] Load dosatorSettings failed',
  props<{ error: Error }>(),
);

export const upsertDosatorSettingRequest = createAction(
  '[DosatorSetting] Upsert dosatorSettingrequest',
  props<{ dosatorSetting: DosatorSetting }>(),
);
export const upsertDosatorSettingSuccess = createAction(
  '[DosatorSetting] Upsert dosatorSettingsuccess',
  props<{ dosatorSetting: DosatorSetting }>(),
);
export const upsertDosatorSettingFailed = createAction(
  '[DosatorSetting] Upsert dosatorSettingfailed',
  props<{ error: Error }>(),
);

export const deleteDosatorSettingRequest = createAction(
  '[DosatorSetting] Delete dosatorSettingrequest',
  props<{ dosatorSetting: DosatorSetting }>(),
);
export const deleteDosatorSettingWithConfirmation = createAction(
  '[DosatorSetting] Confirm Delete dosatorsetting',
  props<{ dosatorSetting: DosatorSetting }>(),
);
export const deleteDosatorSettingSuccess = createAction(
  '[DosatorSetting] Delete dosatorSettingsuccess',
  props<{ dosatorSetting: DosatorSetting }>(),
);
export const deleteDosatorSettingFailed = createAction(
  '[DosatorSetting] Delete dosatorSettingfailed',
  props<{ error: Error }>(),
);

export const upsertDosatorSetting = createAction(
  '[DosatorSetting] Upsert dosatorsetting',
  props<{ dosatorSetting: DosatorSetting }>(),
);
export const setSelectedDosatorSetting = createAction(
  '[DosatorSetting] Set Selected dosatorsetting',
  props<{ dosatorSettingId?: number }>(),
);
